<template>
  <div id="container" ref="containerRef">
    <div id="title">
      <svg id="title-svg" viewBox="0 0 100 20">
        <g>
          <text
            class="title-text"
            x="0"
            y="12"
            font-family="SegoeUI, Segoe UI"
            font-size="10"
            font-weight="normal"
            fill="#00413B"
          >
            Configure MAP Plot
          </text>
        </g>
      </svg>
    </div>
    <div id="y-lims-grid" class="grid-bg">
      <div class="label">
        <svg viewBox="0 0 100 20">
          <g>
            <text
              x="2"
              y="7"
              font-family="SegoeUI, Segoe UI"
              font-size="6"
              font-weight="normal"
              fill="black"
            >
              Y-Limits (mmHg)
            </text>
          </g>
        </svg>
      </div>
      <RangeSlider
        id="upper-target-slider"
        ref="maxSlider"
        name="Max"
        :min="100"
        :max="150"
        :value="yMax"
        @input="limitChanged"
      ></RangeSlider>
      <RangeSlider
        id="lower-target-slider"
        ref="minSlider"
        name="Min"
        :min="0"
        :max="30"
        :value="yMin"
        @input="limitChanged"
      ></RangeSlider>
    </div>
    <svg id="close" viewBox="0 0 40 39" @click="clickClose">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <rect id="bg" fill="#00413B" x="0" y="0" width="100%" height="100%" />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="9 2 20.013 15.845 31.0275928 2 36.0275928 2 22.509 18.982 36.0275928 35.975305 31.0458031 35.975305 20.013 22.116 8.98178971 35.975305 4 35.975305 17.518 18.982 4 2"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import RangeSlider from '../components/RangeSlider'

export default {
  name: 'MAPConfigDialog',
  props: {
    yMin: {
      required: true
    },
    yMax: {
      required: true
    }
  },
  data() {
    return {}
  },
  components: {
    RangeSlider
  },
  methods: {
    limitChanged() {
      this.$emit(
        'limit-changed',
        this.$refs['minSlider'].value,
        this.$refs['maxSlider'].value
      )
    },
    clickClose() {
      this.$emit('close-dialog')
    },
    onResize() {
      let size = this.$refs.containerRef.clientWidth * 0.035
      this.$refs.radioset.$el.style.fontSize = size + 'px'
    }
  },
  mounted() {
    this.selected = this.options[0]
    // Register an event listener when the Vue component is ready
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize()
    })
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.grid-bg {
  background: #efefef;
  border: 1px solid #808080;
}
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
#container {
  position: relative;
  background-color: white;
  border: 2px solid #00413b;
  display: grid;
  box-sizing: border-box;
  padding: 1%;
  grid-template-columns: 100%;
  grid-template-rows: 20% 80%;
}

#close {
  position: absolute;
  width: 8%;
  height: 13%;
  top: 0;
  right: 0;
  background-color: #00413b;
}

#title {
  grid-row: 1;
  grid-column: 1;
  display: flex;
  justify-content: flex-start;
}

#title-svg {
  height: 80%;
}

.label {
  width: 100%;
  height: 100%;
}
#y-lims-grid {
  grid-row: 2;
  grid-column: 1;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 10% 40% 40%;
}
#upper-target-slider {
  grid-row: 2;
  padding-right: 1%;
}
#lower-target-slider {
  grid-row: 3;
  padding-right: 1%;
}
</style>
